import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class TeamEmployeeDbTableDefinition extends DbTableDefinition {
  tableName = 'team_employees';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       label TEXT NOT NULL,
       databag LONGTEXT,
       name LONGTEXT,
       lastname LONGTEXT,
       imsappstatus TEXT,
       primarycarid BIGINT(20),
       primarycarlabel TEXT,
       employmenttypeid BIGINT(20),
       employmenttypelabel TEXT,
       tag LONGTEXT,
       appusername LONGTEXT
      );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'assignedsvemplabel',
        type: 'TEXT',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'assignedsvempid',
        type: 'BIGINT(20)',
      });
    } else {
      this.updateStatements.set(4, [
        `ALTER TABLE ${this.tableName} ADD COLUMN assignedsvemplabel TEXT;`,
      ]);
      this.updateStatements.set(5, [
        `ALTER TABLE ${this.tableName} ADD COLUMN assignedsvempid BIGINT(20);`,
      ]);
    }
  }
}
